import * as CookieConsent from 'vanilla-cookieconsent';

import config from './config';
import CookieConsentHandler from './handler';

export default function init() {
  const cookieConsentHandler = new CookieConsentHandler(config, CookieConsent);

  config.onFirstConsent = cookieConsentHandler.onFirstConsent;
  config.onConsent = cookieConsentHandler.onConsent;
  config.onChange = cookieConsentHandler.onChange;

  CookieConsent.run(config);
}

export * from './utils';
